
import { CardCompfour } from "./Private/Dashboard/DashComponent/CardCompfour";
import { CardCompOne } from "./Private/Dashboard/DashComponent/CardCompOne";
import { CardCompthree } from "./Private/Dashboard/DashComponent/CardCompthree";
import { CardComptwo } from "./Private/Dashboard/DashComponent/CardComptwo";
import { CardCompfive } from "./Private/Dashboard/DashComponent/CardCompfive";
import { Footer } from "./Private/Dashboard/DashComponent/Footer";
import { TableData } from "./Private/Dashboard/DashComponent/TableData";


function MainCotent() {
  return (

    <>
      <div className="row body-scroll"

      >
        <div className="col-12 col-lg-12">
          <CardCompOne />
        </div>
        <div className="col-12 col-lg-12">
          <CardComptwo />
        </div>
        <div className="col-12 col-lg-12 ">
          <div className=" row mt-3 border bg-white">
            <div className="col-12 col-lg-8">
              <CardCompthree />
            </div>
            <div className="col-12 col-lg-4">
              <CardCompfour />
            </div>
          </div>
        </div>
        {/* <CardCompOne/> */}
        <CardCompfive />

      </div>

      {/*  <TableData /> */}
      <Footer />

    </>
  );
}

export default MainCotent;
